import React from "react";
import Routers from "../Route";
import Navbar from "./Navbar";

function Layout() {
  return (
    <>
      <Navbar />
      <Routers />
    </>
  );
}

export default Layout;
